import React            from 'react';
import { SketchPicker } from 'react-color';

function InputColorPicker(props) {

  const { color, onChange, showPicker, switchPicker } = props;

  return (
    <div style={{ paddingTop: 20 }}>
      <div style={{
        padding: 5,
        backgroundColor: '#e3e3e3',
        borderRadius: 2,
        display: 'inline-block',
        cursor: 'pointer',
      }} onClick={ switchPicker }>
        <div style={{ backgroundColor: color, width: 60, height: 15 }}/>
      </div>
      { showPicker &&
        <div onClick={ switchPicker }>
          <SketchPicker color={ color } onChange={ onChange } />
        </div>}
    </div>
  );
}

export default InputColorPicker;